export const LANDING = '/';
export const LOGIN = '/login';
export const SIGNUP = '/signup';
export const PROFILE = '/profile';
export const LEARN = '/learn';
export const PUBLIC_PROFILE = '/p/:username';
export const APP_PROFILE = '/app/profile';
export const APP_LEARN = '/app/learn';
